import React, { useState, useEffect, useRef } from 'react';
import { Check, X } from 'lucide-react';
import './CustomReadinessFilter.css';

const CustomReadinessFilter = ({ 
  options, 
  selectedValues, 
  onSelect, 
  onRemove, 
  getTooltip
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const normalizedOptions = (options || []).map((option) =>
    typeof option === 'object' && option !== null
      ? {
          value: option.value,
          label: option.label ?? option.value,
        }
      : {
          value: option,
          label: option,
        },
  );

  const getOptionLabel = (value) =>
    normalizedOptions.find((option) => option.value === value)?.label ?? value;
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  // Handle option selection
  const handleOptionClick = (optionValue) => {
    if (optionValue === "All") {
      onSelect(["All"], "All");
      setIsOpen(false);
      return;
    }

    let updatedSelected;
    if (!selectedValues.includes(optionValue)) {
      // Add the option, remove "All" if present
      updatedSelected = [...selectedValues.filter(val => val !== "All"), optionValue];
      onSelect(updatedSelected, optionValue);
    } else {
      // Remove the option
      updatedSelected = selectedValues.filter(val => val !== optionValue);
      // If none left, default to "All"
      if (updatedSelected.length === 0) {
        updatedSelected = ["All"];
      }
      onRemove(updatedSelected, optionValue);
    }
  };

return (
  <div className="crfilter-group readiness-filter">
    {/*<Filter size={12} />
    <label>{label}</label>*/}
    
    <div className="dropdown-container" ref={dropdownRef}>
        <div
          className={`readiness-dropdown-select ${isOpen ? 'open' : ''}`}
          onMouseDown={(e) => {
            if (isOpen) {
              // Close when clicking the trigger while open
              e.stopPropagation();
              setIsOpen(false);
            } else {
              setIsOpen(true);
            }
          }}
        >
        <div className="selected-chips">
          {selectedValues.length === 0 || (selectedValues.length === 1 && selectedValues[0] === "All") ? (
            <div className="placeholder">{getOptionLabel("All")}</div>
          ) : (
            selectedValues.map(value => (
              value !== "All" ? (
                <div key={value} className="selected-chip" title={getTooltip ? getTooltip(value): ""}>
                  {getOptionLabel(value)}
                  <button
                    className="chip-remove-btn"
                    onClick={e => {
                      e.stopPropagation();
                      handleOptionClick(value);
                    }}
                    aria-label={`Remove ${value}`}
                    tabIndex={0}
                    type="button"
                  >
                    <X size={14} />
                  </button>
                </div>
              ) : (
                <div key={value} className="selected-chip" title={getTooltip ? getTooltip(value): ""}>
                  {getOptionLabel(value)}
                </div>
              )
            ))
          )}
        </div>
        <div className="dropdown-arrow"></div>
      </div>
      
      {isOpen && (
        <div className="readiness-dropdown-options">
          {normalizedOptions.map((option) => (
            <div 
              key={option.value}
              className={`readiness-dropdown-option ${selectedValues.includes(option.value) ? 'selected' : ''}`}
              onClick={() => handleOptionClick(option.value)}
              title={getTooltip ? getTooltip(option.value) : ""}
            >
              <div className="option-checkbox">
                {selectedValues.includes(option.value) && <Check size={14} />}
              </div>
              <span>{option.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);
};

export default CustomReadinessFilter;
